import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

export interface StateProps extends HTMLProps<HTMLDivElement> {
  name: string;
  message: string;

  spinner?: boolean;
}

function StateComponent(
  { name, message, spinner = false, ...props }: StateProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <div ref={ref} {...props} className={`state ${props.className || ''}`}>
      {spinner && <div uk-spinner="ratio: 1"></div>}

      <h3>{name}</h3>
      <p>{message}</p>
    </div>
  );
}

export default forwardRef(StateComponent);
